import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { reactQueryPut } from "@circle-react/helpers/backendRequestHelpers";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { communityLinkInvalidations } from "@circle-react/lib/queries/communityLinks";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";

export const useLinks = () => {
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const [shouldShowLinks, toggleLinks] = useBoolean(true);
  const [orderedList, setOrderedList] = useState(currentCommunity?.links || []);
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  const { mutate: updateLinksOrder } = useMutation({
    mutationFn: ({ links_order_array }: { links_order_array: any[] }) =>
      reactQueryPut(internalApi.communities.communityLinks.reorder(), {
        links_order_array,
      }),
    onSuccess: () => {
      void communityLinkInvalidations.all();
    },
  });

  const onSort = (reorderedItems: any[]) => {
    const linksOrderArray = reorderedItems.map(link => link.id.toString());

    setOrderedList(reorderedItems);
    updateLinksOrder({ links_order_array: linksOrderArray });
  };

  useEffect(() => {
    /*
    TODO - The query with the key "pundit-user" is causing a re-render when sorting items
    resulting in a jump, impacting in the UX. This is a temporal workaround to prevent it.
    */
    const a = currentCommunity?.links || [];
    const b = orderedList;

    if (a?.length !== b.length) {
      setOrderedList(currentCommunity?.links || []);
      return;
    }
    if (
      a.some(link => link.name !== b.find(l => l.id === link.id).name) ||
      a.some(link => link.url !== b.find(l => l.id === link.id).url) ||
      a.some(
        link =>
          link.may_lead_to_purchase !==
          b.find(l => l.id === link.id).may_lead_to_purchase,
      )
    ) {
      setOrderedList(currentCommunity?.links || []);
    }
  }, [currentCommunity?.links, orderedList]);

  const currentCommunityLinks = currentCommunity?.links || [];
  const canSeeLinks = isAdmin || currentCommunityLinks.length > 0;

  return {
    canSeeLinks,
    shouldShowLinks,
    toggleLinks,
    orderedList,
    onSort,
  };
};
